import { TableCell, TableRow } from '@mui/material';
import { FunctionComponent } from 'react';
import { NumericFormat } from 'react-number-format';
import { IEsrsDetails } from '../../../../../shared/services/generated-report/generated-report.model';

export const ReportingEsrsSixTableSegment: FunctionComponent<{ title: React.ReactNode, data: IEsrsDetails, showPrevious: boolean }> = ({ title, data, showPrevious }) => {
  return (
    <TableRow>
      <TableCell scope='row'>
        {title}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'secondary.light', color: 'primary.dark' }}>
        {data.baseYearEmission ? <NumericFormat value={data.baseYearEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.baseYearEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.baseYearEmission === null ? '-' : ''}
      </TableCell>
      {showPrevious && <TableCell scope='row' sx={{ backgroundColor: 'secondary.light', color: 'primary.dark' }}>
        {data.previousYearEmission ? <NumericFormat value={data.previousYearEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.previousYearEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.previousYearEmission === null ? '-' : ''}
      </TableCell>}
      <TableCell scope='row' sx={{ backgroundColor: 'secondary.light', color: 'primary.dark' }}>
        {data.currentYearEmission ? <NumericFormat value={data.currentYearEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.currentYearEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.currentYearEmission === null ? '-' : ''}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'secondary.light', color: 'primary.dark' }}>
        {data.percentageChangeEmission ? <NumericFormat value={data.percentageChangeEmission} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.percentageChangeEmission === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.percentageChangeEmission === null ? '-' : ''}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'lightGrey.main', color: 'text.secondary' }}>
        {data.targetOne ? <NumericFormat value={data.targetOne} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> : 
          data.targetOne === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.targetOne === null ? '-' : ''}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'lightGrey.main', color: 'text.secondary' }}>
        {data.targetTwo ? <NumericFormat value={data.targetTwo} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.targetTwo === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.targetTwo === null ? '-' : ''}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'lightGrey.main', color: 'text.secondary' }}>
        {data.targetThree ? <NumericFormat value={data.targetThree} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
          data.targetThree === 0 ? <NumericFormat value={0} displayType={'text'} thousandSeparator="," decimalScale={2} fixedDecimalScale={true} /> :
            data.targetThree === null ? '-' : ''}
      </TableCell>
      <TableCell scope='row' sx={{ backgroundColor: 'lightGrey.main', color: 'text.secondary' }}>
        {data.annualPercentageReduction ? `${data.annualPercentageReduction}%` : ''}
      </TableCell>
    </TableRow>
  )
}